export default function ModuleScript({ module }) {
  const { code } = module
  return (
    <div className="module-script" dangerouslySetInnerHTML={{ __html: code }} />
  )
}
